<ns-grid
  class="d-flex flex-column h-100"
  name="ECR_ALL_REQUESTS"
  gridTitle="All Requests"
  fileName="all_requests"
  [columns]="columns"
  [data]="requests"
  [config]="config"
  [loading]="loading"
>
</ns-grid>
